"use strict";

module.exports = function (column) {
  return this.query.hasOwnProperty(column) && this.opts.multiColumns.hasOwnProperty(column);
};


// WEBPACK FOOTER //
// ./src/components/vuetable-2-kernel/compiled/methods/is-multi-filter.js